// extracted by mini-css-extract-plugin
export default {"btn":"ButtonBackTop_btn__gmObZ","animaUp":"ButtonBackTop_animaUp__HKDDf"};